<template>


  <div class="bg-red text-center">
    <span class="text-h2 mb-4">Funktioniert Perfekt und besser mit Android teilen!</span>
  </div>
  <v-card :class="mode === 'card' ? 'mt-2 pa-4' : 'pa-0'" :variant="mode === 'card' ? undefined : 'flat'">
    <div class="text-h6 mb-4">CSV Urladung Steuer-Transaktionen</div>

    <v-row>
      <v-col v-if="showFileInput" cols="12" md="6">
        <v-file-input
          v-model="uploadFile"
          label="CSV Datei (TR oder aus Wiso -Auto falluntescheidung)"
          accept=".csv,text/csv"
          variant="outlined"
          prepend-icon="mdi-file-delimited"
          show-size
          clearable
        />
      </v-col>

      <v-col cols="12" md="2">
        <v-switch
          v-model="uploadDryRun"
          label="Dry Run"
          color="primary"
          inset
        />
      </v-col>

      <v-col cols="12" md="2">
        <v-text-field
          v-model="uploadDelimiter"
          label="Delimiter"
          variant="outlined"
        />
      </v-col>

      <v-col cols="12" md="2">
        <v-text-field
          v-model="uploadCategory"
          label="Category"
          type="number"
          variant="outlined"
        />
      </v-col>

      <v-col cols="12" md="2">
        <v-text-field
          v-model="uploadStockName"
          label="Stock Name"
          variant="outlined"
        />
      </v-col>

      <v-col cols="12">
        <v-text-field
          v-model="uploadBeschreibung"
          label="Beschreibung (so lassen damit werden die alten nicht nochmal geladen"
          variant="outlined"
        />
      </v-col>
    </v-row>

    <div v-if="uploadFile && !showFileInput" class="text-caption text-medium-emphasis mb-4">
      {{ uploadFile.name || 'geteilte CSV' }} - {{ formatFileSize(uploadFile.size) }}
    </div>

    <div class="d-flex ga-3 mb-4 flex-wrap">
      <v-btn
        color="primary"
        :loading="uploadLoading"
        :disabled="!uploadFile || uploadLoading"
        @click="uploadTransactionsCsv"
      >
        {{ uploadDryRun ? 'Dry Run starten' : 'Import starten' }}
      </v-btn>

      <v-btn
        variant="outlined"
        :disabled="uploadLoading"
        @click="resetUpload"
      >
        Zuruecksetzen
      </v-btn>
    </div>

    <v-alert
      v-if="uploadError"
      type="error"
      variant="tonal"
      class="mb-4"
    >
      {{ uploadError }}
    </v-alert>

    <v-alert
      v-if="uploadSuccess"
      type="success"
      variant="tonal"
      class="mb-4"
    >
      {{ uploadSuccess }}
    </v-alert>

    <v-alert
      v-if="uploadImporterMessage"
      type="info"
      variant="tonal"
      class="mb-4"
    >
      {{ uploadImporterMessage }}
    </v-alert>

    <v-card
      v-if="uploadResult"
      variant="outlined"
      class="pa-4"
    >
      <div class="text-subtitle-1 mb-3">Import Ergebnis</div>

      <div><b>Message:</b> {{ uploadResult.message }}</div>
      <div><b>Datei:</b> {{ uploadResult.filename }}</div>
      <div><b>Encoding:</b> {{ uploadResult.encoding }}</div>
      <div><b>Dry Run:</b> {{ uploadResult.dry_run }}</div>

      <v-divider class="my-3" />

      <div v-if="uploadResult.summary">
        <div><b>CSV Zeilen:</b> {{ uploadResult.summary.csv_zeilen }}</div>
        <div><b>Tax correction gefunden:</b> {{ uploadResult.summary.tax_correction_gefunden }}</div>
        <div><b>Neue Buchungen:</b> {{ uploadResult.summary.neue_buchungen }}</div>
        <div><b>In DB gespeichert:</b> {{ uploadResult.summary.in_db_gespeichert }}</div>
        <div><b>Uebersprungen Dublette:</b> {{ uploadResult.summary.uebersprungen_dublette }}</div>
        <div><b>Uebersprungen Fehler:</b> {{ uploadResult.summary.uebersprungen_fehler }}</div>
        <div><b>Gesamtsumme Steuerkorrekturen:</b> {{ uploadResult.summary.gesamtsumme_steuerkorrekturen }}</div>
      </div>

      <v-divider class="my-3" />

      <div class="text-subtitle-2 mb-2">Gefundene Zeilen</div>

      <v-data-table
        v-if="uploadResult.rows && uploadResult.rows.length"
        :headers="uploadHeaders"
        :items="uploadResult.rows"
        :items-per-page="10"
        density="compact"
        class="elevation-1 text-caption"
      />

      <div v-else>
        Keine Zeilen in der Vorschau.
      </div>
    </v-card>
  </v-card>
</template>

<script>
import axios from '@/api/client'
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'TaxCsvTransactionImport',

  props: {
    file: {
      type: Object,
      default: null,
    },
    autoAnalyze: {
      type: Boolean,
      default: false,
    },
    showFileInput: {
      type: Boolean,
      default: true,
    },
    mode: {
      type: String,
      default: 'card',
      validator: value => ['card', 'inline'].includes(value),
    },
  },

  emits: ['imported', 'analyzed', 'error'],

  data: () => ({
    uploadFile: null,
    uploadDryRun: true,
    uploadDelimiter: ';',
    uploadBeschreibung: 'steuer_TR_automatisch_01',
    uploadStockName: 'Steuer',
    uploadCategory: 4,
    uploadLoading: false,
    uploadResult: null,
    uploadError: '',
    uploadSuccess: '',
    uploadImporterMessage: '',
    uploadHeaders: [
      { title: 'Datum', key: 'datum' },
      { title: 'Betrag', key: 'betrag' },
      { title: 'Stock Name', key: 'stocks_transactions_stocks_name' },
      { title: 'Empfaenger', key: 'empfaenger' },
      { title: 'Verwendungszweck', key: 'verwendungszweck' },
    ],
  }),

  computed: {
    ...mapGetters({
      transactions: 'stateTransactions',
      stocks: 'stateStocks',
      user: 'stateUser',
    }),

    currentUserId () {
      return Number(this.user?.iduser ?? 0)
    },
  },

  watch: {
    file: {
      immediate: true,
      async handler (file) {
        if (!file) return
        this.uploadFile = file
        if (this.autoAnalyze) {
          await this.uploadTransactionsCsv()
        }
      },
    },
  },

  methods: {
    ...mapActions(['updateTransaction', 'getStocks', 'createStock']),

    getSelectedFile (value) {
      if (Array.isArray(value)) return value[0] || null
      return value || null
    },

    readFileAsText (file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader()
        reader.onload = () => resolve(String(reader.result || ''))
        reader.onerror = () => reject(reader.error || new Error('Datei konnte nicht gelesen werden.'))
        reader.readAsText(file, 'utf-8')
      })
    },

    normalizeCsvHeader (value) {
      return String(value || '')
        .replace(/^\uFEFF/, '')
        .trim()
        .toLowerCase()
        .replace(/\u00e4/g, 'ae')
        .replace(/\u00f6/g, 'oe')
        .replace(/\u00fc/g, 'ue')
        .replace(/\u00df/g, 'ss')
        .replace(/\u00c3\u00a4/g, 'ae')
        .replace(/\u00c3\u00b6/g, 'oe')
        .replace(/\u00c3\u00bc/g, 'ue')
        .replace(/\u00c3\u0178/g, 'ss')
        .replace(/[^a-z0-9]+/g, '_')
        .replace(/^_+|_+$/g, '')
    },

    parseCsvHeaderLine (line, delimiter) {
      const headers = []
      let cell = ''
      let inQuotes = false

      for (let index = 0; index < String(line || '').length; index += 1) {
        const char = line[index]
        const next = line[index + 1]

        if (char === '"' && inQuotes && next === '"') {
          cell += '"'
          index += 1
          continue
        }

        if (char === '"') {
          inQuotes = !inQuotes
          continue
        }

        if (char === delimiter && !inQuotes) {
          headers.push(this.normalizeCsvHeader(cell))
          cell = ''
          continue
        }

        cell += char
      }

      headers.push(this.normalizeCsvHeader(cell))
      return headers.filter(Boolean)
    },

    detectTaxUploadImporter (csvText) {
      const firstLine = String(csvText || '')
        .split(/\r?\n/)
        .find(line => line.trim())

      if (!firstLine) {
        throw new Error('Die CSV-Datei ist leer oder enthaelt keinen Header.')
      }

      const commaHeaderSet = new Set(this.parseCsvHeaderLine(firstLine, ','))
      const semicolonHeaderSet = new Set(this.parseCsvHeaderLine(firstLine, ';'))

      const hasTrExportStructure =
        commaHeaderSet.has('datetime') &&
        commaHeaderSet.has('date') &&
        commaHeaderSet.has('account_type') &&
        commaHeaderSet.has('transaction_id')

      if (hasTrExportStructure) {
        return {
          key: 'tr',
          endpoint: '/transactions/import-tr-tax',
          delimiter: ',',
          label: 'Trade Republic Transaktionsexport',
        }
      }

      const hasWisoStructure =
        semicolonHeaderSet.has('wertstellung') &&
        semicolonHeaderSet.has('empfaenger_auftraggeber') &&
        semicolonHeaderSet.has('verwendungszweck') &&
        semicolonHeaderSet.has('betrag')

      if (hasWisoStructure) {
        return {
          key: 'wiso',
          endpoint: '/transactions/import-wiso-tax',
          delimiter: this.uploadDelimiter || ';',
          label: 'WISO Steuer/Banking Export',
        }
      }

      throw new Error('CSV-Struktur nicht erkannt. Erwartet wird WISO Export oder Trade Republic Transaktionsexport.')
    },

    parseGermanNumber (value) {
      if (value === null || value === undefined || value === '') return null
      if (typeof value === 'number') {
        return Number.isFinite(value) ? value : null
      }

      const text = String(value).trim()
      const normalized = text.includes(',')
        ? text.replace(/\./g, '').replace(',', '.')
        : text.replace(/\s/g, '')
      const numberValue = Number(normalized)
      return Number.isFinite(numberValue) ? numberValue : null
    },

    parseAnyDateIso (value) {
      if (!value) return ''
      const text = String(value).trim()
      const german = text.match(/^(\d{1,2})\.(\d{1,2})\.(\d{4})/)

      if (german) {
        return `${german[3]}-${String(german[2]).padStart(2, '0')}-${String(german[1]).padStart(2, '0')}`
      }

      const isoDate = text.match(/^(\d{4})-(\d{2})-(\d{2})/)
      if (isoDate) {
        return isoDate[0]
      }

      const date = new Date(text)
      if (Number.isNaN(date.getTime())) return ''
      return date.toISOString().slice(0, 10)
    },

    getWisoUploadRowAmount (row) {
      return this.parseGermanNumber(
        row?.betrag ??
        row?.amount ??
        row?.stocks_transactions_preisV02 ??
        row?.stocks_transactions_preis ??
        row?.preis
      )
    },

    getWisoUploadRowDate (row) {
      return this.parseAnyDateIso(
        row?.datum ??
        row?.date ??
        row?.stocks_transactions_datum ??
        row?.wertstellung
      )
    },

    getPositiveWisoUploadRowsForCash (result, maxRows = null) {
      const summary = result?.summary || {}
      const rowLimit = Number(maxRows ?? summary.neue_buchungen ?? summary.in_db_gespeichert ?? 0)
      if (!Number.isFinite(rowLimit) || rowLimit <= 0) return []

      const rows = Array.isArray(result?.rows) ? result.rows : []
      return rows
        .map((row) => ({
          row,
          amount: this.getWisoUploadRowAmount(row),
          date: this.getWisoUploadRowDate(row),
        }))
        .filter((item) => Number.isFinite(item.amount) && item.amount > 0)
        .slice(0, rowLimit)
    },

    getWisoDuplicateCount (result) {
      const summary = result?.summary || {}
      const duplicateCount = Number(summary.uebersprungen_dublette ?? 0)
      return Number.isFinite(duplicateCount) ? duplicateCount : 0
    },

    getWisoNewBookingCount (result) {
      const summary = result?.summary || {}
      const newCount = Number(summary.neue_buchungen ?? 0)
      return Number.isFinite(newCount) ? newCount : 0
    },

    getStockUserId (stock) {
      return Number(
        stock?.user_iduser?.iduser ??
        stock?.user_iduser_id ??
        stock?.user_iduser ??
        0
      )
    },

    findUploadStock () {
      const list = Array.isArray(this.stocks) ? this.stocks : []
      const uploadStockName = String(this.uploadStockName || 'Steuer').trim().toLowerCase()
      const currentUserId = this.currentUserId

      return list.find((stock) =>
        String(stock?.stocks_name || '').trim().toLowerCase() === uploadStockName &&
        (!currentUserId || this.getStockUserId(stock) === currentUserId)
      ) || null
    },

    findUserCashStock () {
      const list = Array.isArray(this.stocks) ? this.stocks : []
      const currentUserId = this.currentUserId

      return list.find((stock) =>
        (!currentUserId || this.getStockUserId(stock) === currentUserId) &&
        (
          String(stock?.stocks_name || '').trim().toLowerCase() === '0_ccash' ||
          String(stock?.stocks_Handelsplatz || '').trim().toLowerCase() === 'typ_cash'
        )
      ) || null
    },

    async ensureUploadStockId () {
      if (!this.currentUserId) {
        throw new Error('Aktueller User konnte nicht ermittelt werden.')
      }

      if (!Array.isArray(this.stocks) || !this.stocks.length) {
        await this.getStocks()
      }

      let stock = this.findUploadStock()
      if (!stock) {
        const stockName = this.uploadStockName || 'Steuer'
        const today = new Date().toISOString()

        const createdStock = await this.createStock({
          stocks_name: stockName,
          stocks_Handelsplatz: stockName,
          stocks_GoogleId: stockName,
          stocks_Kaufdatum: today,
          stocks_ISIN: stockName,
          stocks_Kaufkurs: 0,
          stocks_Menge: '0',
          stocks_Typ: 'Cash',
          stocks_Status: 1,
          stock_Umrechnungskurs: 1,
          stock_Realsiert: 0,
          stock_Aktuellerkurs: 0,
          stocks_Land: 'DE',
          stocks_stoploss: 0,
          stock_25ProzentVerkauflimit: 0,
          stock_delta1_prozent: 0,
          stock_delta5_prozent: 0,
          stock_delta20_prozent: 0,
          user_iduser_id: this.currentUserId,
        })

        const createdStockId = Number(createdStock?.idstocks ?? createdStock?.id ?? 0)
        if (createdStockId) return createdStockId

        await this.getStocks()
        stock = this.findUploadStock()
      }

      const stockId = Number(stock?.idstocks ?? 0)
      if (!stockId) {
        throw new Error(`Stock "${this.uploadStockName || 'Steuer'}" konnte nicht angelegt werden.`)
      }

      return stockId
    },

    createTaxUploadFormData (uploadStockId, dryRun, force = false, importer = null) {
      const formData = new FormData()
      formData.append('file', this.getSelectedFile(this.uploadFile))
      formData.append('dry_run', dryRun)
      formData.append('force', force ? 'true' : 'false')
      formData.append('delimiter', importer?.delimiter || this.uploadDelimiter)
      formData.append('beschreibung', this.uploadBeschreibung)
      formData.append('category', this.uploadCategory)
      if (Number(this.uploadCategory) === 4 && uploadStockId) {
        formData.append('idstocks', uploadStockId)
        formData.append('stocks_idstocks', uploadStockId)
      }
      return formData
    },

    async postTaxUpload (uploadStockId, dryRun, force = false, importer) {
      const token = localStorage.getItem('token')
      return axios.post(
        importer.endpoint,
        this.createTaxUploadFormData(uploadStockId, dryRun, force, importer),
        {
          headers: {
            ...(token ? { Authorization: `Bearer ${token}` } : {}),
            'Content-Type': 'multipart/form-data',
          },
        }
      )
    },

    async bookPositiveWisoUploadCashDeposits (result, maxRows = null) {
      const positiveRows = this.getPositiveWisoUploadRowsForCash(result, maxRows)
      if (!positiveRows.length) return 0

      if (!Array.isArray(this.stocks) || !this.stocks.length) {
        await this.getStocks()
      }

      const cashStock = this.findUserCashStock()
      const cashStockId = Number(cashStock?.idstocks ?? 0)
      if (!cashStockId) {
        throw new Error('Cash-Stock "0_ccash" fuer den aktuellen User wurde nicht gefunden.')
      }

      let bookedCount = 0
      for (const item of positiveRows) {
        await axios.post('/manualtransaction', {
          stocks_transactions_category: 5,
          stocks_idstocks: cashStockId,
          stocks_menge: 1,
          stocks_gebuehr: 0,
          stocks_transactions_preis: item.amount,
          stocks_transactions_datum: `${item.date || new Date().toISOString().slice(0, 10)}T00:00:00`,
          stocks_transactions_beschreibung: `${this.uploadBeschreibung || 'WISO Steuer'} Cash Einzahlung`
        })
        bookedCount += 1
      }

      await this.getStocks()
      return bookedCount
    },

    extractTransactionId (item) {
      const source = item || {}
      const candidates = [
        source.idstocks_transactions,
        source.transaction?.idstocks_transactions,
        source.transaction_id,
        source.idtransactions,
        source.stocks_transactions_id,
        source.transactions_id,
        source.id,
        source.transaction?.id,
      ]

      const found = candidates.find((value) => Number.isFinite(Number(value)) && Number(value) > 0)
      return found != null ? Number(found) : null
    },

    buildEditableTransaction (tx) {
      const source = tx || {}
      return {
        idstocks_transactions: this.extractTransactionId(source) ?? 0,
        stocks_transactions_category: Number(source.stocks_transactions_category ?? 0),
        stocks_idstocks: Number(source.stocks_idstocks ?? 0),
        stocks_user_iduser: Number(source.stocks_user_iduser ?? 0),
        stocks_menge: Number(source.stocks_menge ?? 0),
        stocks_gebuehr: Number(source.stocks_gebuehr ?? 0),
        stocks_transactions_preisprostueck: Number(
          source.stocks_transactions_preisprostueck ??
          source.stocks_transactions_preis ??
          0
        ),
        stocks_transactions_preis: Number(source.stocks_transactions_preis ?? 0),
        stocks_transactions_preisV02: Number(source.stocks_transactions_preisV02 ?? 0),
        stocks_transactions_datum: source.stocks_transactions_datum
          ? String(source.stocks_transactions_datum).slice(0, 10)
          : '',
        stocks_transactions_beschreibung: source.stocks_transactions_beschreibung ?? '',
      }
    },

    isMissingUploadStockId (tx) {
      return !Number(tx?.stocks_idstocks ?? 0)
    },

    isCurrentTaxUploadTransaction (tx) {
      return (
        Number(tx?.stocks_transactions_category ?? 0) === 4 &&
        String(tx?.stocks_transactions_beschreibung || '') === String(this.uploadBeschreibung || '') &&
        this.isMissingUploadStockId(tx)
      )
    },

    async assignUploadStockToImportedTaxTransactions (stockId) {
      const numericStockId = Number(stockId || 0)
      if (!numericStockId) return 0

      await this.$store.dispatch('getTransactions')

      const rows = (Array.isArray(this.transactions) ? this.transactions : [])
        .filter((tx) => this.isCurrentTaxUploadTransaction(tx) && this.extractTransactionId(tx))

      for (const tx of rows) {
        await this.updateTransaction({
          id: this.extractTransactionId(tx),
          form: {
            ...this.buildEditableTransaction(tx),
            stocks_idstocks: numericStockId,
          },
        })
      }

      if (rows.length) {
        await this.$store.dispatch('getTransactions')
      }

      return rows.length
    },

    resetUpload () {
      this.uploadFile = this.file || null
      this.uploadDryRun = true
      this.uploadDelimiter = ';'
      this.uploadBeschreibung = 'steuer_TR_automatisch_01'
      this.uploadStockName = 'Steuer'
      this.uploadCategory = 4
      this.uploadLoading = false
      this.uploadResult = null
      this.uploadError = ''
      this.uploadSuccess = ''
      this.uploadImporterMessage = ''
    },

    async uploadTransactionsCsv () {
      this.uploadError = ''
      this.uploadSuccess = ''
      this.uploadResult = null
      this.uploadImporterMessage = ''

      if (!this.uploadFile) {
        this.uploadError = 'Bitte eine CSV-Datei auswaehlen.'
        return
      }

      try {
        this.uploadLoading = true
        const selectedFile = this.getSelectedFile(this.uploadFile)
        if (!selectedFile) {
          this.uploadError = 'Bitte eine CSV-Datei auswaehlen.'
          return
        }

        const csvText = await this.readFileAsText(selectedFile)
        const importer = this.detectTaxUploadImporter(csvText)
        this.uploadImporterMessage = `Genutzter Importer: ${importer.label} (${importer.endpoint})`

        const isDryRun = Boolean(this.uploadDryRun)
        let uploadStockId = 0
        if (Number(this.uploadCategory) === 4) {
          uploadStockId = await this.ensureUploadStockId()
        }

        let forceImport = false
        let response
        let previewResult = null

        if (isDryRun) {
          response = await this.postTaxUpload(uploadStockId, true, false, importer)
        } else {
          const previewResponse = await this.postTaxUpload(uploadStockId, true, false, importer)
          previewResult = previewResponse.data
          const duplicateCount = this.getWisoDuplicateCount(previewResult)
          const newBookingCount = this.getWisoNewBookingCount(previewResult)
          if (newBookingCount <= 0 && duplicateCount > 0) {
            this.uploadResult = previewResult
            const shouldImportAgain = window.confirm(
              `Alle ${duplicateCount} gefundene(n) Buchung(en) sind bereits vorhanden. Trotzdem nochmal importieren?`
            )
            if (!shouldImportAgain) {
              this.uploadSuccess = 'Import abgebrochen. Es wurde nichts gebucht.'
              return
            }
            forceImport = true
          }

          response = await this.postTaxUpload(uploadStockId, false, forceImport, importer)
        }

        this.uploadResult = response.data
        let fixedRows = 0
        let cashRows = 0
        if (!isDryRun && uploadStockId) {
          fixedRows = await this.assignUploadStockToImportedTaxTransactions(uploadStockId)
        }

        if (!isDryRun) {
          const cashSource = previewResult || response.data
          const cashRowLimit = this.getWisoNewBookingCount(cashSource)
          if (importer.key === 'wiso') {
            cashRows = await this.bookPositiveWisoUploadCashDeposits(cashSource, cashRowLimit)
          }
        }

        if (isDryRun) {
          this.uploadSuccess = `Dry Run erfolgreich durchgefuehrt. ${this.uploadImporterMessage}`
          this.$emit('analyzed', this.uploadResult)
        } else {
          const successParts = [`Import erfolgreich durchgefuehrt. ${this.uploadImporterMessage}`]
          if (fixedRows) {
            successParts.push(`Steuer-Stock bei ${fixedRows} Buchungen gesetzt.`)
          }
          if (cashRows) {
            successParts.push(`${cashRows} positive Steuer-Ertraege als Cash-Einzahlung gebucht.`)
          }
          this.uploadSuccess = successParts.join(' ')
          this.$emit('imported', this.uploadResult)
        }
      } catch (error) {
        console.error('uploadTransactionsCsv error', error)
        this.uploadSuccess = ''
        this.uploadError =
          error?.response?.data?.detail ||
          error?.response?.data?.message ||
          error?.message ||
          'Upload fehlgeschlagen.'
        this.$emit('error', error)
      } finally {
        this.uploadLoading = false
      }
    },

    formatFileSize (size) {
      const numberValue = Number(size)
      if (!Number.isFinite(numberValue)) return ''
      return `${(numberValue / 1024).toFixed(1)} KB`
    },
  },
}
</script>
